import React from 'react';
import './App.css';
import Header from './Header'

function App() {
    return (
        <div className='App'>
            <Header />
            <div className='Content'>
                <h1> Coming Soon !!! </h1>
            </div>
        </div>
    );
}

export default App;
